document.addEventListener("DOMContentLoaded", () => {

  // ─── Mobile menu ─────────────────────────────────────────────────────────
  const burger = document.querySelector(".js-burger");
  const menu   = document.querySelector(".js-header-nav");
  if (burger && menu) {
    burger.addEventListener("click", () => {
      const open = menu.classList.toggle("active");
      burger.classList.toggle("active", open);
      document.body.classList.toggle("locked", open);
    });
    window.addEventListener("resize", () => {
      if (window.innerWidth > 992) {
        menu.classList.remove("active");
        burger.classList.remove("active");
        document.body.classList.remove("locked");
      }
    });
  }

  // ─── Search overlay ───────────────────────────────────────────────────────
  const openSearchBtn  = document.querySelector(".js-open-search");
  const closeSearchBtn = document.querySelector(".js-close-search");
  const searchOverlay  = document.querySelector(".js-search-overlay");
  if (openSearchBtn && closeSearchBtn && searchOverlay) {
    openSearchBtn.addEventListener("click", (e) => {
      e.preventDefault();
      searchOverlay.classList.add("active");
      document.body.classList.add("locked");
      setTimeout(() => {
        const input = searchOverlay.querySelector("input");
        if (input) input.focus();
      }, 100);
    });
    closeSearchBtn.addEventListener("click", () => {
      searchOverlay.classList.remove("active");
      document.body.classList.remove("locked");
    });
    searchOverlay.addEventListener("click", (e) => {
      if (e.target === searchOverlay) {
        searchOverlay.classList.remove("active");
        document.body.classList.remove("locked");
      }
    });
  }

  // ─── Market Watch — full-screen, one-slide-at-a-time slider ────────────────
  const trendingTrack = document.querySelector(".js-trending-track");
  const trendingSlides = trendingTrack ? Array.from(trendingTrack.querySelectorAll(".aiw-trending__slide")) : [];
  if (trendingTrack && trendingSlides.length > 1) {
    const prevBtn = document.querySelector(".js-trending-prev");
    const nextBtn = document.querySelector(".js-trending-next");
    const dots = Array.from(document.querySelectorAll(".js-trending-dots .aiw-trending__dot"));
    let current = 0;

    const goTo = (index) => {
      current = (index + trendingSlides.length) % trendingSlides.length;
      trendingTrack.style.transform = `translateX(-${current * 100}%)`;
      trendingSlides.forEach((slide, i) => slide.setAttribute("aria-hidden", i === current ? "false" : "true"));
      dots.forEach((dot, i) => {
        dot.classList.toggle("is-active", i === current);
        dot.setAttribute("aria-selected", i === current ? "true" : "false");
      });
    };

    if (prevBtn) prevBtn.addEventListener("click", () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener("click", () => goTo(current + 1));
    dots.forEach((dot, i) => dot.addEventListener("click", () => goTo(i)));

    let touchStartX = 0;
    trendingTrack.addEventListener("touchstart", (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    trendingTrack.addEventListener("touchend", (e) => {
      const delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 50) {
        goTo(delta < 0 ? current + 1 : current - 1);
      }
    });
  }

  // ─── FAQ accordion ─────────────────────────────────────────────────────────
  document.querySelectorAll(".js-faq-item").forEach((item) => {
    const trigger = item.querySelector(".js-faq-trigger");
    if (!trigger) return;
    trigger.addEventListener("click", () => {
      const open = !item.classList.contains("is-open");
      item.classList.toggle("is-open", open);
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

});
